import React from 'react';
import styled from 'styled-components';
import MenuBurger from 'icons/src/MenuBurger';
import CoreButton from 'gatsby-theme-core/src/components/button/index';

const MenuBurgerButton = ({ className, onClick, menuName }) => (
  <StyledButton
    className={className}
    aria-label="Open menu"
    onClick={onClick}
    menuName={menuName}
  >
    <MenuBurger />
  </StyledButton>
);

const StyledButton = styled(CoreButton).attrs({
  wrapper: true,
  nav: true,
  navType: 'hamburger_menu',
  eventAction: 'slideout',
})`
  svg {
    width: 2rem;
    height: auto;
  }
`;

export default styled(MenuBurgerButton)``;
